import 'whatwg-fetch';

import {
	AppDispatch,
	RootState,
} from '@/store/store';

import type { ApiErrorResp } from '@/types/endpoints/internal/resp/ApiErrorResp';
import type {
	PaymentStripeCreateIntentProps,
	PaymentStripeCreateIntentResp,
	PaymentTransbankConfirmProps,
	PaymentAddExternalProps,
	PaymentAddBuylistProps,
	PaymentAddBuylistResp,
	PaymentRefundProps,
	PaymentEmptyResp,
} from '@/types/endpoints/internal/payment/PaymentProps';

import {
	ENDPOINT_PAYMENT_SQUARE_AUTHORIZE,
	ENDPOINT_PAYMENT_STRIPE_AUTHORIZE,
	ENDPOINT_PAYMENT_STRIPE_CREATE_INTENT,
	ENDPOINT_PAYMENT_TRANSBANK_CONFIRM_PAYMENT,
	ENDPOINT_PAYMENT_ADD_EXTERNAL,
	ENDPOINT_PAYMENT_ADD_BUYLIST,
	ENDPOINT_PAYMENT_REFUND_PAYMENT,
} from '@/constants/endpoints';

import PaymentRecord, { PaymentRecordApiRespProps } from '@/models/payments/PaymentRecord';

import { stringFormat } from '@/utils/formatting';
import {
	fetchTitan,
	getUrlParams,
} from '@/utils/request';


/******************************
*******  Synchronous  *********
******************************/


// None yet



/******************************
*******  Asynchronous  ********
******************************/



export function paymentsSquareAuthorize(uuid: string, code: string, signal: AbortSignal | null = null) {
	return async (dispatch: AppDispatch, getState: () => RootState): Promise<PaymentEmptyResp> => {

		const getParams = { code: code };

		const endpoint = stringFormat(ENDPOINT_PAYMENT_SQUARE_AUTHORIZE, { uuid: uuid }) + getUrlParams(getParams);
		const options = {
			method: 'get',
			signal,
		};

		return fetchTitan(dispatch, getState, endpoint, options)
			.then((resp: PaymentEmptyResp) => {
				return Promise.resolve(resp);
			})
			.catch((errResp: ApiErrorResp) => {
				return Promise.reject(errResp);
			});
	};
}


export function paymentsStripeAuthorize(uuid: string, code: string, signal: AbortSignal | null = null) {
	return async (dispatch: AppDispatch, getState: () => RootState): Promise<PaymentEmptyResp> => {

		const getParams = { code: code };

		const endpoint = stringFormat(ENDPOINT_PAYMENT_STRIPE_AUTHORIZE, { uuid: uuid }) + getUrlParams(getParams);
		const options = {
			method: 'get',
			signal,
		};

		return fetchTitan(dispatch, getState, endpoint, options)
			.then((resp: PaymentEmptyResp) => {
				return Promise.resolve(resp);
			})
			.catch((errResp: ApiErrorResp) => {
				return Promise.reject(errResp);
			});
	};
}


export function paymentsStripeCreatePaymentIntent(methodUuid: string, intentData: PaymentStripeCreateIntentProps, signal: AbortSignal | null = null) {
	return async (dispatch: AppDispatch, getState: () => RootState): Promise<PaymentStripeCreateIntentResp> => {

		const endpoint = stringFormat(ENDPOINT_PAYMENT_STRIPE_CREATE_INTENT, { uuid: methodUuid });
		const options = {
			method: 'post',
			body: JSON.stringify(intentData),
			signal,
		};

		return fetchTitan(dispatch, getState, endpoint, options)
			.then((resp: PaymentStripeCreateIntentResp) => {
				return Promise.resolve(resp);
			})
			.catch((errResp: ApiErrorResp) => {
				return Promise.reject(errResp);
			});
	};
}


export function paymentsTransbankConfirm(confirmData: PaymentTransbankConfirmProps, uuid: string, signal: AbortSignal | null = null) {
	return async (dispatch: AppDispatch, getState: () => RootState): Promise<PaymentRecord> => {

		const endpoint = stringFormat(ENDPOINT_PAYMENT_TRANSBANK_CONFIRM_PAYMENT, { uuid: uuid });
		const options = {
			method: 'post',
			body: JSON.stringify(confirmData),
			signal,
		};

		return fetchTitan(dispatch, getState, endpoint, options)
			.then((resp: PaymentRecordApiRespProps) => {
				return Promise.resolve(new PaymentRecord(resp));
			})
			.catch((errResp: ApiErrorResp) => {
				return Promise.reject(errResp);
			});
	};
}


export function paymentsAddExternal(paymentData: PaymentAddExternalProps, methodUuid: string, signal: AbortSignal | null = null) {
	return async (dispatch: AppDispatch, getState: () => RootState): Promise<PaymentEmptyResp> => {

		const endpoint = stringFormat(ENDPOINT_PAYMENT_ADD_EXTERNAL, { uuid: methodUuid });
		const options = {
			method: 'post',
			body: JSON.stringify(paymentData),
			signal,
		};

		return fetchTitan(dispatch, getState, endpoint, options)
			.then((resp: PaymentEmptyResp) => {
				return Promise.resolve(resp);
			})
			.catch((errResp: ApiErrorResp) => {
				return Promise.reject(errResp);
			});
	};
}


export function paymentsAddBuylistPayment(paymentData: PaymentAddBuylistProps, methodUuid: string, signal: AbortSignal | null = null) {
	return async (dispatch: AppDispatch, getState: () => RootState): Promise<PaymentAddBuylistResp> => {

		const endpoint = stringFormat(ENDPOINT_PAYMENT_ADD_BUYLIST, { paymentMethodUuid: methodUuid });
		const options = {
			method: 'post',
			body: JSON.stringify(paymentData),
			signal,
		};

		return fetchTitan(dispatch, getState, endpoint, options)
			.then((resp: PaymentAddBuylistResp) => {
				return Promise.resolve(resp);
			})
			.catch((errResp: ApiErrorResp) => {
				return Promise.reject(errResp);
			});
	};
}


export function paymentsRefundPayment(refundData: PaymentRefundProps, paymentRecordUuid: string, signal: AbortSignal | null = null) {
	return async (dispatch: AppDispatch, getState: () => RootState): Promise<PaymentEmptyResp> => {

		const endpoint = stringFormat(ENDPOINT_PAYMENT_REFUND_PAYMENT, { publicUuid: paymentRecordUuid });
		const options = {
			method: 'post',
			body: JSON.stringify(refundData),
			signal,
		};

		return fetchTitan(dispatch, getState, endpoint, options)
			.then((resp: PaymentEmptyResp) => {
				return Promise.resolve(resp);
			})
			.catch((errResp: ApiErrorResp) => {
				return Promise.reject(errResp);
			});
	};
}
